















import {
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CLocationAutocompleteInput from '~/components/shared/configurable/location/CLocationAutocompleteInput.vue'
import { GeocodingSearchLocation } from '~/models/location/geocoding'
import { createSearchGeolocationString } from '~/utils/geolocation'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CLocationAutocompleteInput
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)
    const selectedGeolocation = ref<GeocodingSearchLocation | null>(
      facet.value?.values?.selected?.geolocations || null
    )

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }
        selectedGeolocation.value =
          facet.value?.values?.selected?.geolocations || null
      }
    )

    function onLocationsChange(locations: GeocodingSearchLocation[]) {
      if (locations.length === 0) {
        emit('update:modelValue', {
          name: 'rich-geolocation',
          value: []
        })
      } else {
        emit('update:modelValue', {
          name: 'rich-geolocation',
          value: locations.map(createSearchGeolocationString)
        })
      }
    }

    return {
      facet,
      selectedGeolocation,
      onLocationsChange
    }
  }
})
